import React from 'react'
import {Pie} from 'react-chartjs-2'
import PropTypes from 'prop-types';
import {objectWithoutProperties} from '../../../../utils/utils'


//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
};

//================ Default Property Value =====================
const defaultProps={
    
};

const PieChart=(props)=>{

    const _props=props,
            children=_props.children,
            className=_props.className,
            attribute=objectWithoutProperties(props,'children');
        
    return (
        React.createElement(
            Pie,
            {className:className,attribute},
            children
        )
    )
}

PieChart.propTypes=propsType;
PieChart.defaultProps=defaultProps;

export default PieChart;